import { Show } from "shared/components";
import { cx } from "shared/utils";

type Props = {
  group?: boolean;
  title: string;
  subtitle?: string;
  className?: string;
  subtitleClassName?: string;
};

export const GroupTypeLabel = ({
  title,
  subtitle,
  className,
  subtitleClassName
}: Props) => {
  return (
    <label className={cx("font-medium", className)}>
      {title}
      <Show if={subtitle}>
        <span className={cx("text-content-300", subtitleClassName)}>
          {" " + subtitle}
        </span>
      </Show>
    </label>
  );
};
